export const hasTodoPrimitives = (items = []) =>
  items.some((item) => (item.primitive_inputs ?? []).length > 0);

export const findPrimitiveByKey = (items = [], key) => {
  for (const item of items) {
    for (const prim of item.primitive_inputs ?? []) {
      if (prim.key === key) return prim;
    }
  }
  return null;
};

export const buildPrimitiveValueByKey = (items = [], values = {}) => {
  const result = {};
  for (const item of items) {
    for (const prim of item.primitive_inputs ?? []) {
      if (prim.key) result[prim.key] = (values[prim.substep_id]?.string_value ?? "").trim();
    }
  }
  return result;
};

export const hasPrimitiveValue = (prim, values = {}) => {
  const v = values[prim.substep_id];
  return !!(
    (v?.string_value ?? "").toString().trim() ||
    (Array.isArray(v?.string_list_value) && v.string_list_value.length > 0)
  );
};

// Some MARK_STEP_COMPLETE payloads intentionally store true for every disclosure
// item so the backend does not persist false bools. When reading the form back,
// prefer the item whose child fields actually contain values.
export const getSelectedDisclosureItem = (items = [], values = {}) => {
  const selectedItems = items.filter((item) => !!values[item.substep_id]?.bool_value);
  return selectedItems.find((item) =>
    (item.primitive_inputs ?? []).some((prim) => hasPrimitiveValue(prim, values))
  ) ?? selectedItems[0] ?? null;
};

export const isNoDisclosureItem = (item) => {
  const title = (item?.title ?? "").toLowerCase().trim();
  const key = (item?.key ?? "").toLowerCase();
  return title === "no" || key.endsWith("_no");
};
